export default "__VITE_ASSET__7165a710__"